import React from "react";
import { Button, Result, Row } from "antd";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";

const NotFound = () => {
  const navigate = useNavigate();
  const handleBackClick = () => {
    navigate(-1);
  }
  return (
    <Row justify={"center"} style={{ marginBottom: "80px" }}>
      <Result
        status="404"
        title="Page Not Found"
        extra={
          <>
          <Link to="/" replace>
            <Button type="primary">Back to Home</Button>
          </Link>
          <Button type="primary" onClick={handleBackClick}>Back</Button>
          </>
        }
      />
    </Row>
  );
};

export default NotFound;
